import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from "@angular/core";
import { FiltroListaDistribuzioneVO } from "@app/shared/vo/gescor/filtro-lista-distribuzioneVO";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
 

@Component({
  selector: "app-modale-ricerca-liste-distribuzione",
  templateUrl: "./modale-ricerca-liste-distribuzione.component.html",
})
export class ModaleRicercaListeDistribuzioneComponent implements OnInit {
  public filtroListaDistribuzioneVO: FiltroListaDistribuzioneVO = new FiltroListaDistribuzioneVO();

  public disabled: boolean = true;
 
  @ViewChild("templateRicercaListeDistribuzione", { static: false })
  public ricercaListeModal: TemplateRef<any>;
  public modalRef: BsModalRef;
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };
  @Output()
  public ricercaEmit: EventEmitter<FiltroListaDistribuzioneVO> = new EventEmitter<FiltroListaDistribuzioneVO>();

  constructor( 
    private modalService: BsModalService) {}

  ngOnInit() {}

  public openModal(){
  this.modalRef = this.modalService.show(
    this.ricercaListeModal,
    this.config
  );
  }

  emettiFiltroListeDistribuzione(){
    this.modalRef.hide();
    this.ricercaEmit.emit(this.filtroListaDistribuzioneVO);
    this.resetRicerca();
  }
 
  resetRicerca(){
   this.filtroListaDistribuzioneVO = new FiltroListaDistribuzioneVO();
   this.disabled = true;
  }

}
